import { render, staticRenderFns } from "./UIMultiSelect.vue?vue&type=template&id=94cba6cc&scoped=true"
import script from "./UIMultiSelect.vue?vue&type=script&lang=js"
export * from "./UIMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./UIMultiSelect.vue?vue&type=style&index=0&id=94cba6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cba6cc",
  null
  
)

export default component.exports